var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 電腦技能 "),
            _c("span", { staticClass: "en-text" }, [_vm._v("Computer skills")]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.skill.ComputerSkill,
                callback: function ($$v) {
                  _vm.$set(_vm.skill, "ComputerSkill", $$v)
                },
                expression: "skill.ComputerSkill",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 培訓紀錄 "),
            _c("span", { staticClass: "en-text" }, [_vm._v("Training record")]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.skill.TrainingRecord,
                callback: function ($$v) {
                  _vm.$set(_vm.skill, "TrainingRecord", $$v)
                },
                expression: "skill.TrainingRecord",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 證照檢定 "),
            _c("span", { staticClass: "en-text" }, [_vm._v("License test")]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.skill.Certificate,
                callback: function ($$v) {
                  _vm.$set(_vm.skill, "Certificate", $$v)
                },
                expression: "skill.Certificate",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 論文(題目) "),
            _c("span", { staticClass: "en-text" }, [_vm._v("Thesis (title)")]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.skill.PaperTheme,
                callback: function ($$v) {
                  _vm.$set(_vm.skill, "PaperTheme", $$v)
                },
                expression: "skill.PaperTheme",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 論文(摘要) "),
            _c("span", { staticClass: "en-text" }, [
              _vm._v("Thesis (Abstract)"),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.skill.PaperSummary,
                callback: function ($$v) {
                  _vm.$set(_vm.skill, "PaperSummary", $$v)
                },
                expression: "skill.PaperSummary",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 工作專長 "),
            _c("span", { staticClass: "en-text" }, [_vm._v("Work expertise")]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 6,
                maxlength: "10000",
                "show-word-limit": "",
              },
              model: {
                value: _vm.skill.Specialty,
                callback: function ($$v) {
                  _vm.$set(_vm.skill, "Specialty", $$v)
                },
                expression: "skill.Specialty",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "edit-btn-wrap" }, [
        _c(
          "button",
          {
            staticClass: "put-btn",
            attrs: { type: "button" },
            on: { click: _vm.saveSkill },
          },
          [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }